import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, vShow as _vShow, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full overflow-y-auto"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Limit Rules ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row h-screen py-6"
}
const _hoisted_7 = { class: "w-2/3 px-4 text-12px xxl:text-14px overflow-y-auto" }
const _hoisted_8 = { class: "flex flex-row w-3/4" }
const _hoisted_9 = { class: "py-3 w-full mr-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Limit Rules", -1)
const _hoisted_11 = { class: "flex flex-row w-3/4" }
const _hoisted_12 = { class: "py-3 w-full mr-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 flex flex-row space-x-2" }, [
  /*#__PURE__*/_createVNode("p", null, "Deskripsi"),
  /*#__PURE__*/_createVNode("p", { class: "text-gray-500" }, "(Optional)")
], -1)
const _hoisted_14 = { class: "inline-block relative w-full" }
const _hoisted_15 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-end px-2 py-4 text-gray-700" }
const _hoisted_16 = { class: "text-12px text-gray-lp-500" }
const _hoisted_17 = { class: "flex flex-row w-3/4" }
const _hoisted_18 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_19 = { class: "font-semibold text-black-lp-300 flex-row flex space-x-2" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", null, "Applied to", -1)
const _hoisted_21 = { class: "inline-block relative w-full" }
const _hoisted_22 = { class: "flex flex-row w-3/4" }
const _hoisted_23 = {
  key: 0,
  class: "flex flex-row w-3/4 py-3 relative"
}
const _hoisted_24 = { class: "flex flex-row w-3/4" }
const _hoisted_25 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-1.5" }, " Batas Limit (IDR) ", -1)
const _hoisted_27 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-1.5" }, " Batas Limit (RM) ", -1)
const _hoisted_29 = { class: "flex flex-row w-3/4" }
const _hoisted_30 = { class: "flex flex-col h-full text-12px border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Limit Rules "),
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ")
], -1)
const _hoisted_32 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_34 = { class: "ml-4" }
const _hoisted_35 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_36 = { class: "py-3" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Limit Rules", -1)
const _hoisted_38 = { class: "my-1 text-black-lp-300" }
const _hoisted_39 = { class: "flex" }
const _hoisted_40 = { class: "py-3" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_42 = { class: "my-1 text-black-lp-300" }
const _hoisted_43 = { class: "text-gray-lp-500" }
const _hoisted_44 = { class: "py-3" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_46 = { class: "my-1 text-black-lp-300" }
const _hoisted_47 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading === true)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              (!_ctx.isError)
                ? (_openBlock(), _createBlock(_component_button_fill, {
                    key: 0,
                    title: "Simpan",
                    onClick: _ctx.onOpenSave,
                    class: "px-8 bg-red-lp-300"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.fetchBalanceData
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail.name,
                        class: 
                `py-2 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode("div", _hoisted_14, [
                        _withDirectives(_createVNode("textarea", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataDetail.description = $event)),
                          onInput: _cache[3] || (_cache[3] = e => _ctx.inputDescription(e.target.value)),
                          cols: "70",
                          rows: "7",
                          maxlength: "1000",
                          placeholder: "Tulis deskripsi balance limit rule disini",
                          class: 
                  `focus:border-red-lp-100
            py-1.5 xxl:py-3 px-4 rounded border focus:outline-none focus:shadow my-1
            text-black-lp-300 w-full ${_ctx.isDisabled && 'bg-white'}`
                
                        }, null, 34), [
                          [_vModelText, _ctx.dataDetail.description]
                        ]),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("p", _hoisted_16, _toDisplayString(_ctx.dataDetail.description.length) + "/1000 ", 1)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode("img", {
                          onMouseenter: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openTooltip && _ctx.openTooltip(...args))),
                          onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeTooltip && _ctx.closeTooltip(...args))),
                          src: 
                  _ctx.isOpenTooltip
                    ? require('@/app/ui/assets/svg/info-red.svg')
                    : require('@/app/ui/assets/svg/info.svg')
                ,
                          alt: ""
                        }, null, 40, ["src"])
                      ]),
                      (_ctx.isOpenTooltip)
                        ? (_openBlock(), _createBlock(_component_Tooltip, {
                            key: 0,
                            title: "Applied to",
                            message: "Apabila salah satu account type sudah memiliki balance limit rules & statusnya aktif, account type tsb tidak dapat dipilih lagi saat pembuatan limit rules",
                            footer: "",
                            isArrowBottom: true,
                            style: {"width":"300px","margin-left":"300px","margin-top":"-150px"}
                          }))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_21, [
                        _createVNode("input", {
                          type: "text",
                          placeholder: _ctx.dataDetail.appliedTo,
                          class: 
                  `focus:border-red-lp-100
            py-2 my-1.5 xxl:py-3 px-4 rounded border focus:outline-none focus:shadow
            text-black-lp-300 w-full ${_ctx.isDisabled && 'bg-white'}`
                ,
                          disabled: _ctx.isDisabled
                        }, null, 10, ["placeholder", "disabled"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_22, [
                    _createVNode(_component_DataWrapper, {
                      label: "Min. Balance Saldo",
                      class: "w-6/12 pr-6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          prefix: "IDR",
                          modelValue: _ctx.minBalance,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.minBalance = $event)),
                          format: _ctx.formatRupiah,
                          onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                          placeholder: "100,000,000",
                          maxLength: "15"
                        }, null, 8, ["modelValue", "format"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DataWrapper, {
                      label: "Min. Balance Saldo (RM)",
                      class: "w-6/12 pr-12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          prefix: "RM",
                          modelValue: _ctx.minBalanceMY,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.minBalanceMY = $event)),
                          format: _ctx.formatRinggit,
                          onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                          placeholder: "100,000,000",
                          maxLength: "15"
                        }, null, 8, ["modelValue", "format"])
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.dataDetail.appliedTo === 'Pos')
                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                        _createVNode(_component_CheckboxV2, {
                          label: "COD Delivery Partner",
                          hint: "(Opsional)",
                          textSize: 14,
                          keyName: "CODDeliveryPartnerAdd",
                          value: _ctx.dataDetail.isCodDelivery,
                          "onUpdate:value": _ctx.onCheckedCODDeliveryPartner
                        }, null, 8, ["value", "onUpdate:value"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode(_component_Select, {
                        dataSelect: _ctx.typeData,
                        onOpenSelect: _ctx.onOpenTypeSelect,
                        onCloseSelect: _ctx.onCloseTypeSelect,
                        onChooseSelect: _ctx.onSelectType,
                        value: _ctx.typeName,
                        isOpenMenu: _ctx.typeSelect,
                        class: "w-full z-10"
                      }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                    ]),
                    _createVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_Select, {
                        dataSelect: _ctx.typeDataMY,
                        onOpenSelect: _ctx.onOpenTypeSelectMY,
                        onCloseSelect: _ctx.onCloseTypeSelectMY,
                        onChooseSelect: _ctx.onSelectTypeMY,
                        value: _ctx.typeNameMY,
                        isOpenMenu: _ctx.typeSelectMY,
                        class: "w-full z-10"
                      }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _createVNode(_component_DataWrapper, {
                      label: "Min. Withdraw Amount",
                      class: "w-6/12 pr-6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          prefix: "IDR",
                          modelValue: _ctx.minWithdrawAmount,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.minWithdrawAmount = $event)),
                          format: _ctx.formatRupiah,
                          onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                          placeholder: "100,000,000",
                          maxLength: "15"
                        }, null, 8, ["modelValue", "format"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DataWrapper, {
                      label: "Min. Withdraw Amount (RM)",
                      class: "w-6/12 pr-12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          prefix: "RM",
                          modelValue: _ctx.minWithdrawAmountMY,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.minWithdrawAmountMY = $event)),
                          format: _ctx.formatRinggit,
                          onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                          placeholder: "100,000,000",
                          maxLength: "15"
                        }, null, 8, ["modelValue", "format"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", {
                        onClick: _cache[14] || (_cache[14] = () => _ctx.onOpenRoute()),
                        class: 
                `toggle-switch inline-block cursor-pointer ${
                  _ctx.isRoute() ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                }`
              
                      }, [
                        _hoisted_33
                      ], 2),
                      _createVNode("div", _hoisted_34, " Limit Rules " + _toDisplayString(_ctx.isRoute() ? "Aktif" : "Tidak Aktif"), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.isRoute() ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${_ctx.isRoute() ? 'text-green-lp-200' : 'text-red-lp-500'}`
                
                        }, _toDisplayString(_ctx.isRoute() ? "Active" : "Inactive"), 3)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode("div", _hoisted_42, _toDisplayString(_ctx.createdAt), 1),
                    _createVNode("div", _hoisted_43, _toDisplayString(_ctx.createdBy), 1)
                  ]),
                  _createVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode("div", _hoisted_46, _toDisplayString(_ctx.updateAt), 1),
                    _createVNode("div", _hoisted_47, _toDisplayString(_ctx.updateBy), 1)
                  ])
                ])
              ]))
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseRoute,
      onSubmit: _ctx.changeRoute,
      title: _ctx.isRoute() ? 'Non-aktifkan Limit Rules' : 'Aktifkan Limit Rules',
      message: 
      _ctx.isRoute()
        ? 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.'
        : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod'
    ,
      image: "warning",
      textSuccess: _ctx.isRoute() ? 'Non-aktifkan' : 'Aktifkan',
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openRoute]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalSuccess,
      title: "Perubahan Disimpan",
      message: `${_ctx.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openModalSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Detail Limit Rules",
      message: 
      `Anda yakin akan menyimpan perubahan untuk Limit Rules “${_ctx.dataDetail.name}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave()]
    ])
  ], 64))
}